module.exports = {"1000":"Жен.","1001":"Муж."};